var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DPlan",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #DPlan .cls-1 {\n        fill: #ff7600;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_583",
    "data-name": "Pfad 583",
    className: "cls-1",
    d: "M20 40a20 20 0 1120-20A20.023 20.023 0 0120 40Zm0-37.849a17.849 17.849 0 1017.849 17.849A17.87 17.87 0 0020 2.151Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_584",
    "data-name": "Pfad 584",
    className: "cls-1",
    d: "M20 30 29 18H23V12H17V18H11L20 30Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDplan);
export default __webpack_public_path__ + "static/media/dplan.26d2c44ca88674cab67a4a94b4a685da.svg";
export { ForwardRef as ReactComponent };